import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Layout, Alert } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { EstimateLayoutQuery } from './__generated__/EstimateLayoutQuery.graphql';
import ActionHeader from './ActionHeader';
import environment from '../../Environment';
import ContentWrapper from '../../components/UI/Layout/ContentWrapper';
import LoadingSpin from '../../components/UI/Feedback/LoadingSpin';
import { getEstimateNumber } from '../../lib/modelHelpers/estimate';

import styles from './index.module.less';

const { Header, Footer } = Layout;

function EstimateLayout(props) {
  const Component = props.component;
  const route = props.route;

  dayjs.locale('de');

  const webToken = route.match.params.token;

  if (!webToken) {
    return <Alert message={'Angebot konnte nicht gefunden werden'} type={'error'} />;
  }

  return (
    <QueryRenderer<EstimateLayoutQuery>
      environment={environment}
      query={query}
      variables={{
        webToken: webToken,
      }}
      render={({ error, props: queryProps }) => {
        if (error) {
          return (
            <ContentWrapper>
              <Alert message={error.message} type={'error'} />
            </ContentWrapper>
          );
        } else if (queryProps) {
          if (!queryProps.estimate) {
            return (
              <ContentWrapper>
                <Alert message={'Angebot konnte nicht gefunden werden'} type={'error'} />
              </ContentWrapper>
            );
          }

          const estimate = queryProps.estimate;

          return (
            <Layout className={styles.layout}>
              <Header className={styles.header}>
                <div className={styles.headerContainer}>
                  <div className={styles.headerLeft}>
                    <span className={styles.headerLabel}>Angebot</span>
                    <span className={styles.headerNumber}>{getEstimateNumber(estimate)}</span>
                  </div>
                  {estimate.status !== 'ACCEPTED' &&
                    estimate.status !== 'DECLINED' &&
                    !dayjs().isAfter(dayjs(estimate.validityDate, 'YYYY-MM-DD'), 'day') && (
                      <ActionHeader estimate={estimate} />
                    )}
                </div>
              </Header>
              <main className={styles.main}>
                <div className={styles.contentContainer}>
                  <Component route={route} estimate={estimate} />
                </div>
              </main>
              <Footer className={styles.footer}>
                Erstellt mit{' '}
                <a href='https://www.mendato.com' target='_blank' rel='noopener noreferrer'>
                  Mendato
                </a>
              </Footer>
            </Layout>
          );
        }
        return (
          <ContentWrapper>
            <LoadingSpin />
          </ContentWrapper>
        );
      }}
    />
  );
}

const query = graphql`
  query EstimateLayoutQuery($webToken: ID!) {
    estimate(webToken: $webToken) {
      id
      company {
        companyName
        legalForm
        streetAddress
        zip
        city
        taxNumber
        vatId
        email
        phone
        fax
        iban
        bic
        registerCourt
        companyRegistrationNumber
        managingDirectors {
          name
        }
        logoUrl
      }
      customer {
        type
        salutation
        firstName
        lastName
        companyName
        streetAddress
        zip
        city
      }
      status
      number
      numberPrefix
      items {
        id
        title
        description
        quantity
        unitPrice
        taxRate
        unit
        object {
          name
          streetAddress
          zip
          city
        }
      }
      estimateDate
      validityDate
      hasKleinunternehmerregelung
      introductionText
      closingText
      estimatePdf
      scopeOfWorkPdf
      webToken
      webEnabled
      declineReason
      declineNote
      acceptedAt
      declinedAt
    }
  }
`;

export default EstimateLayout;
